import React from "react";

import WalletWithdrawals from "./index";

const IndianWalletWithdrawals = () => {
  return <WalletWithdrawals creatorCountryType="india" />;
};
export default IndianWalletWithdrawals;
